import { toServicePrincipal } from "../service_actor.js";
import { TransactionResult, TransactionState, TransactionType } from "@biteinc/enums";
//#region src/factories/universal_transaction_factory.ts
let UniversalTransactionFactory;
(function(_UniversalTransactionFactory) {
	function buildUnstartedSaleTransactionData(location, order, clientId, transactionJson, amount, paymentsApiVersion, currencyCode) {
		return {
			clientId,
			clientOrderId: order.data.clientId,
			orderId: order.id,
			paymentsApiVersion,
			type: TransactionType.Sale,
			state: TransactionState.None,
			result: TransactionResult.None,
			amount,
			startedAt: Date.now(),
			currencyCode,
			...transactionJson,
			locationId: location.id,
			siteId: location.data.siteId,
			orgId: location.data.orgId
		};
	}
	_UniversalTransactionFactory.buildUnstartedSaleTransactionData = buildUnstartedSaleTransactionData;
	function buildRefundTransactionData(caller, location, amount, clientId, originalTransaction, paymentsApiVersion) {
		return {
			clientId,
			clientOrderId: originalTransaction.data.clientOrderId,
			orgId: location.data.orgId,
			siteId: location.data.siteId,
			locationId: originalTransaction.data.locationId,
			orderId: originalTransaction.data.orderId,
			...originalTransaction.data.kioskId && { kioskId: originalTransaction.data.kioskId },
			originalTransactionId: originalTransaction.id,
			..."_tag" in caller ? {
				refunderPrincipal: toServicePrincipal(caller),
				refunderUsername: caller.name
			} : {
				refunderUserId: caller.id,
				refunderUsername: caller.data.username
			},
			gateway: originalTransaction.data.gateway,
			type: TransactionType.Refund,
			state: TransactionState.None,
			result: TransactionResult.None,
			amount,
			startedAt: Date.now(),
			paymentsApiVersion
		};
	}
	_UniversalTransactionFactory.buildRefundTransactionData = buildRefundTransactionData;
})(UniversalTransactionFactory || (UniversalTransactionFactory = {}));
//#endregion
export { UniversalTransactionFactory };

//# sourceMappingURL=universal_transaction_factory.js.map